__turbopack_context__.v({
  "action": "feature-card-module-scss-module__tsPuWG__action",
  "app_light_theme": "feature-card-module-scss-module__tsPuWG__app_light_theme",
  "button": "feature-card-module-scss-module__tsPuWG__button",
  "heading": "feature-card-module-scss-module__tsPuWG__heading",
  "icon": "feature-card-module-scss-module__tsPuWG__icon",
  "link": "feature-card-module-scss-module__tsPuWG__link",
  "main": "feature-card-module-scss-module__tsPuWG__main",
  "root": "feature-card-module-scss-module__tsPuWG__root",
  "text": "feature-card-module-scss-module__tsPuWG__text",
  "variant-horizontal": "feature-card-module-scss-module__tsPuWG__variant-horizontal",
  "variant-vertical": "feature-card-module-scss-module__tsPuWG__variant-vertical",
});
